<div class="periods-block">
	<p-accordion [activeIndex]="activeIndex" (onOpen)="onTabChanged($event)">
		<p-accordionTab *ngFor="let payPeriod of payPeriods">
			<p-header>
				<div class="left-side">
					{{payPeriod.start | date: 'MMM d'}} - {{payPeriod.finish | date: 'MMM d yyyy'}}
				</div>
				<div class="right-side">
					Total: {{getDuration(payPeriod.workDuration)}}
				</div>
			</p-header>

			<app-timesheet [startPeriod]="payPeriod.start" [endPeriod]="payPeriod.finish">
			</app-timesheet>
		</p-accordionTab>
	</p-accordion>
</div>